import update from 'react/lib/update';
import * as actionConsts from './actions';

export const initState = {
	pics: [],
	isShowingDeleteModal: null
}

export default (state = initState, action) => {
	switch (action.type) {
		case actionConsts.GET_IMAGES_SUCCESS:
			return update(state, {
				pics: {
					$set: action.images
				}
		});
		case actionConsts.ADD_PICTURE:
			return update(state, {
				pics: {
					$splice: [[0,0,action.pic]]
				}
		});
		case actionConsts.UPDATE_PICTURE:
			return update(state, {
				pics: {
					[action.index]: {
							$set: action.pic
					}
				}
		});
		case actionConsts.UPDATE_DESCRIPTION:
			return update(state, {
				pics: {
					[action.index]: {
						description: {
							$set: action.text
						}
					}
				}
		});
		case actionConsts.SET_IS_SHOWING_DELETE_MODAL:
			return update(state, {
				isShowingDeleteModal: {
					$set: action.imageIndex
				}
		});
		case actionConsts.DELETE_IMAGE_SUCCCESS:
			return update(state, {
				pics: {
					$splice: [[action.imageIndex,1]]
				},
				isShowingDeleteModal: {
					$set: null
				}
		});

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Images/reducer.js